import { useQuery } from '@tanstack/react-query'
import { tipologieBoxApi, configurazioniApi } from '@/api/box'
import { fetchAllPaginatedResults } from '@/utils/pagination'

// ========== Tipologie Box ==========

export const useTipologieBox = (params) => {
  return useQuery({
    queryKey: ['tipologie-box', params],
    queryFn: () => tipologieBoxApi.getAll(params).then(res => res.data),
  })
}

export const useTipologiaBox = (id, { enabled = true } = {}) => {
  return useQuery({
    queryKey: ['tipologie-box', id],
    queryFn: () => tipologieBoxApi.getById(id).then(res => res.data),
    enabled: enabled && !!id,
  })
}

export const useTipologieBoxAttive = ({ enabled = true } = {}) => {
  return useQuery({
    queryKey: ['tipologie-box', 'attive'],
    queryFn: () => fetchAllPaginatedResults(
      (params) => tipologieBoxApi.getAll(params),
      { attivo: true }
    ),
    enabled,
    staleTime: 5 * 60 * 1000, // 5 minuti
  })
}

export const useCalcolaPrezzoBox = (id) => {
  return useQuery({
    queryKey: ['tipologie-box', id, 'prezzo'],
    queryFn: () => tipologieBoxApi.calcolaPrezzo(id).then(res => res.data),
    enabled: !!id,
  })
}

// ========== Configurazioni Scatola ==========

export const useConfigurazioniScatola = (params) => {
  return useQuery({
    queryKey: ['configurazioni-scatola', params],
    queryFn: () => configurazioniApi.getAll(params).then(res => res.data),
  })
}

export const useConfigurazioniScatolaAttive = ({ enabled = true } = {}) => {
  return useQuery({
    queryKey: ['configurazioni-scatola', 'attive'],
    queryFn: () => fetchAllPaginatedResults(
      (params) => configurazioniApi.getAll(params),
      { attivo: true }
    ),
    enabled,
    staleTime: 5 * 60 * 1000,
  })
}
